import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { StorageKeys } from 'src/app/share/enums/storage.enum';
import { CompanyServiceService } from 'src/app/share/services/company-service/company-service.service';
import { MasterMakeService } from 'src/app/share/services/master-make/master-make.service';
import { MasterModelService } from 'src/app/share/services/master-model/master-model.service';
import { ReturnsService } from 'src/app/share/services/returns/returns.service';
import { StockService } from 'src/app/share/services/stock/stock.service';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { RegExpPatterns } from 'src/app/share/enums/regex-pattern.enum';
import { MessageService } from 'src/app/share/sharedsubject';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { PaymentAccountsService } from 'src/app/share/services/payment-account/payment-accounts.service';

@Component({
    selector: 'app-return-and-replace',
    templateUrl: './return-and-replace.component.html',
    styleUrls: ['./return-and-replace.component.scss'],
    standalone: false
})
export class ReturnAndReplaceComponent implements OnInit {
  customSearchFn = () => true;
  returnReplaceForm: FormGroup;
  filteredActiveBranches: any[] = [];
  isLoading = false;
  userDetails: any;
  tyreSizeObj: any = { page: 0, searchTerm: '', list: [] };
  tyreMakeObj: any = { page: 0, searchTerm: '', list: [] };
  tyreModelObj: any = {}
  resMsg: string;
  tyreModelReturnList: { search: string, list: any[], page: number }[] = [{ search: '', list: [], page: 0 }];
  tyreModelReplaceList: { search: string, list: any[], page: number }[] = [{ search: '', list: [], page: 0 }];

  showStockArray = false;
  isFromInvoice = false;

  paymentModes = [
    { label: 'UPI', value: 'UPI' },
    { label: 'Cash', value: 'Cash' },
    { label: 'Bank Transfer', value: 'BankTransfer' },
    { label: 'Card', value: 'Card' },
    { label: 'Bajaj Finance', value: 'BajajFinance'},
  ];
  paymentAccountsList: any[] = [];
  paymentAccountsLoading = false;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly stockService: StockService,
    private readonly masterModelService: MasterModelService,
    private readonly masterMakeService: MasterMakeService,
    private readonly companyService: CompanyServiceService,
    private readonly returnsService: ReturnsService,
    private readonly storageService: StorageService,
    private readonly router: Router,
    private readonly messageService: MessageService,
    private readonly paymentAccountsService: PaymentAccountsService,
  ) {
    this.userDetails = this.storageService.getDataFromLocalStorage(
      StorageKeys.SELF_DETAILS
    );
    this.returnReplaceForm = this.formBuilder.group({
      toBranch: this.userDetails?.enrollmentType === 'Company' ? [null, Validators.required] : [null],
      invoiceNumber: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(30)]],
      customerPhone: [null, [Validators.pattern(RegExpPatterns.MobilePattern), Validators.required]],
      returnStock: this.formBuilder.array([this.returnDetailsGroup()]),
      replaceStock: this.formBuilder.array([this.replaceDetailsGroup()]),
      paymentMode: ['UPI', Validators.required],
      paymentAccount: [null, Validators.required]
    })
  }

  returnDetailsGroup(item?: any): FormGroup {
    let quantityVal = null;
    let priceVal = null;

    if (item) {
      quantityVal = item.editedQuantity ?? item.quantity;
      priceVal = item.editedtyresAmount ?? item.tyresAmount;
    }

    return this.formBuilder.group({
      tyreSize: [item ? item.tyreSize : null, Validators.required],
      tyreMake: [item ? item.tyreMake : null, Validators.required],
      tyreModel: [item ? item.tyreModel : null],
      quantity: [
        quantityVal,
        [
          Validators.required,
          Validators.min(1),
          ...(item ? [Validators.max(quantityVal)] : [])
        ]
      ],
      purchasingPrice: [
        priceVal,
        [
          Validators.required,
          Validators.min(0),
          ...(item ? [Validators.max(priceVal)] : [])
        ]
      ]
    });
  }

  replaceDetailsGroup(item?: any): FormGroup {
    return this.formBuilder.group({
      tyreSize: [item ? item.tyreSize : null, Validators.required],
      tyreMake: [item ? item.tyreMake : null, Validators.required],
      tyreModel: [item ? item.tyreModel : null],
      quantity: [item ? item.quantity : null, [Validators.required, Validators.min(1)]],
      tyresAmount: [item ? item.tyresAmount : null, [Validators.required, Validators.min(0)]],
    });
  }

  get returnStock(): FormArray {
    return this.returnReplaceForm.get('returnStock') as FormArray;
  }

  addItem(index: number): void {
    this.returnStock.push(this.returnDetailsGroup());
    this.tyreModelReturnList.push({ search: '', list: [], page: 0 });
  }

  removeItem(index: number): void {
    this.returnStock.removeAt(index);
    this.tyreModelReturnList.splice(index, 1);
  }

  get replaceStock(): FormArray {
    return this.returnReplaceForm.get('replaceStock') as FormArray;
  }

  replaceAddItem(index: number): void {
    this.replaceStock.push(this.replaceDetailsGroup());
    this.tyreModelReplaceList.push({ search: '', list: [], page: 0 });
  }

  replaceRemoveItem(index: number): void {
    this.replaceStock.removeAt(index);
    this.tyreModelReplaceList.splice(index, 1);
  }

  ngOnInit(): void {
    if (this.userDetails?.enrollmentType === 'Company') {
      this.getAllCompanyList();
      this.returnReplaceForm.get('toBranch')?.setValidators([Validators.required]);
      this.returnReplaceForm.get('toBranch')?.setValue(null, { emitEvent: false });
    } else {
      this.returnReplaceForm.get('toBranch')?.setValue(this.userDetails?.company);
      this.loadPaymentAccounts();
    }
    this.initData();
    this.returnReplaceForm.valueChanges.subscribe(() => {
      this.updatePaymentValidators();
    });
  }

  updatePaymentValidators() {
    const paymentAccountControl = this.returnReplaceForm.get('paymentAccount');
    const paymentModeControl = this.returnReplaceForm.get('paymentMode');
    if (this.totalAmount === 0) {
      paymentAccountControl?.clearValidators();
      paymentModeControl?.clearValidators();
    } else {
      paymentAccountControl?.setValidators([Validators.required]);
      paymentModeControl?.setValidators([Validators.required]);
    }
    paymentAccountControl?.updateValueAndValidity({ emitEvent: false });
    paymentModeControl?.updateValueAndValidity({ emitEvent: false });
  }

  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length > 10) {
      inputElement.value = inputElement.value.slice(0, 10);
      this.returnReplaceForm.controls['customerPhone'].setValue(inputElement.value);
    }
  }

  onInvoiceInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    let val = inputElement.value;
    if (val.startsWith(' ')) {
      val = val.trimStart();
      inputElement.value = val;
      this.returnReplaceForm.controls['invoiceNumber'].setValue(val);
    }
  }

  onInvoiceChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const trimmed = inputElement.value.trim();
    inputElement.value = trimmed;
    this.returnReplaceForm.controls['invoiceNumber'].setValue(trimmed);
  }

  getAllCompanyList() {
    this.companyService.getToCompanyList().subscribe((res: any) => {
      this.filteredActiveBranches = res.data?.filter((c: any) => c.status === 'Active') || [];
    });
  }

  get totalReturnAmount(): number {
    let total = 0;
    const stockArray = this.returnStock?.value || [];
    stockArray.forEach((item: any) => {
      const qty = Number(item.quantity) || 0;
      const amt = Number(item.purchasingPrice) || 0;
      total += qty * amt;
    });
    return total;
  }

  get totalReplaceAmount(): number {
    let total = 0;
    const stockArray = this.replaceStock?.value || [];
    stockArray.forEach((item: any) => {
      const qty = Number(item.quantity) || 0;
      const amt = Number(item.tyresAmount) || 0;
      total += qty * amt;
    });
    return total;
  }

  get totalAmount(): number {
    return this.totalReplaceAmount - this.totalReturnAmount;
  }

  onBranchChange() {
    this.loadPaymentAccounts();
  }

  loadPaymentAccounts() {
    const branch = this.returnReplaceForm.value.toBranch;
    const mode = this.returnReplaceForm.value.paymentMode;
    if (!branch || !mode) {
      this.paymentAccountsList = [];
      this.returnReplaceForm.get('paymentAccount')?.setValue(null);
      return;
    }

    this.paymentAccountsLoading = true;
    this.paymentAccountsService.getCompanyPaymentAccount({
      company: branch, paymentType: mode,page: 0,
      status: true, sort: '_id', sortDir: 1
    }).subscribe({
      next: (res: any) => {
        this.paymentAccountsLoading = false;
        this.paymentAccountsList = res.data || [];
        
        const defaultAcc = this.paymentAccountsList.find((a: any) => a.default);
        if (defaultAcc) {
          this.returnReplaceForm.get('paymentAccount')?.setValue(defaultAcc._id);
        } else if (this.paymentAccountsList.length > 0) {
          this.returnReplaceForm.get('paymentAccount')?.setValue(this.paymentAccountsList[0]._id);
        } else {
          this.returnReplaceForm.get('paymentAccount')?.setValue(null);
        }
      },
      error: () => {
        this.paymentAccountsLoading = false;
        this.paymentAccountsList = [];
        this.returnReplaceForm.get('paymentAccount')?.setValue(null);
      }
    });
  }

  onSubmit() {
    if (this.showStockArray) {
      this.saveReturnReplaceData();
    } else {
      this.fetchInvoiceData();
    }
  }

  fetchInvoiceData() {
    if (this.isLoading) return;
    this.resMsg = '';
    this.isLoading = true;
    const params = {
      company: this.returnReplaceForm.value.toBranch,
      invoiceNumber: this.returnReplaceForm.value.invoiceNumber
    };
    this.stockService.getStockDataByInvoice(params).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.resMsg = '';
        this.showStockArray = true;
        const invoiceData = res.data;
        if (invoiceData?.stock?.length > 0) {
          this.isFromInvoice = true;
          const returnFormArray = this.returnStock;
          const replaceFormArray = this.replaceStock;
          returnFormArray.clear();
          replaceFormArray.clear();
          this.tyreModelReturnList = [];
          this.tyreModelReplaceList = [];

          // Bind data to return stock
          invoiceData.stock.forEach((item: any) => {
            returnFormArray.push(this.returnDetailsGroup(item));
            this.tyreModelReturnList.push({ search: '', list: [{ name: item.tyreModel }], page: 0 });
          });

          // Add one empty replace stock
          replaceFormArray.push(this.replaceDetailsGroup());
          this.tyreModelReplaceList.push({ search: '', list: [], page: 0 });
          this.initData();

          this.loadPaymentAccounts();
        } else {
          this.isFromInvoice = false;
          const returnFormArray = this.returnStock;
          const replaceFormArray = this.replaceStock;
          returnFormArray.clear();
          replaceFormArray.clear();
          this.tyreModelReturnList = [];
          this.tyreModelReplaceList = [];
          returnFormArray.push(this.returnDetailsGroup());
          this.tyreModelReturnList.push({ search: '', list: [], page: 0 });
          replaceFormArray.push(this.replaceDetailsGroup());
          this.tyreModelReplaceList.push({ search: '', list: [], page: 0 });
          this.initData();
          this.loadPaymentAccounts();
        }
      },
      error: (error: any) => {
        this.isLoading = false;
        this.resMsg = error?.error?.error?.message || error?.error?.message || 'Failed to fetch invoice details';
        this.showStockArray = false;
        this.isFromInvoice = false;
      }
    });
  }

  saveReturnReplaceData() {
    if (this.returnReplaceForm.invalid || this.isLoading) return;
    this.resMsg = '';
    this.isLoading = true;
    const paymentAccounts = this.totalAmount === 0 ? [] : [
      {
        paymentId: this.returnReplaceForm.value.paymentAccount,
        amount: this.totalAmount,
        mode: this.returnReplaceForm.value.paymentMode
      }
    ];
    const payload = {
      ...this.returnReplaceForm.value,
      totalAmount: this.totalAmount,
      paymentAccounts: paymentAccounts
    };
    delete payload.paymentMode;
    delete payload.paymentAccount;
    this.returnsService.saveExchangeDetails(payload).subscribe({
      next: (res: any) => {
      setTimeout(() => {
        this.messageService.sendMessage(res.message);
      })
      this.resMsg = res.message;
      this.isLoading = false;
      this.router.navigate(['/order-list'])
    },
      error: (error) => {
      this.isLoading = false;
      this.resMsg = error?.error?.error?.message || error?.error?.message || 'Failed to submit return replace details';
    }
    });
  }

  getTyreSize() {
    const apiParams: any = { page: this.tyreSizeObj.page };
    if (this.tyreSizeObj.searchTerm) apiParams.searchTerm = this.tyreSizeObj.searchTerm;
    this.stockService.getTyreDetails(apiParams).subscribe((res: any) => {
      const newData = res.data || [];
      this.tyreSizeObj.list = [...(this.tyreSizeObj.list || []), ...newData];
    });
  }

  getTyreModel(selectedMake: any, index: number, type: 'return' | 'replace') {
    this.masterModelService.getTyreModelList(selectedMake, this.tyreModelObj).subscribe((res: any) => {
      let newData = res.data || [];
      if (type === 'return') {
        this.tyreModelReturnList[index].list = [
          ...(this.tyreModelReturnList[index].list || []),
          ...newData
        ];
      } else {
        this.tyreModelReplaceList[index].list = [
          ...(this.tyreModelReplaceList[index].list || []),
          ...newData
        ];
      }
    });
  }

  getTyreMake() {
    this.masterMakeService.getTyreMakeBySize(this.tyreMakeObj.page, this.tyreMakeObj.searchTerm).subscribe((res: any) => {
      const newData = res.data || [];
      this.tyreMakeObj.list = [...(this.tyreMakeObj.list || []), ...newData];
    });
  }

  onScrollTyreSize() {
    this.tyreSizeObj.page++;
    this.getTyreSize();
  }

  onTyreSizeInputChange(event: any) {
    this.tyreSizeObj.page = 0;
    this.tyreSizeObj.searchTerm = event?.term ? event.term : '';
    this.tyreSizeObj.list = [];
    this.getTyreSize();
  }

  onSizeClose() {
    if (this.tyreSizeObj.searchTerm) {
      this.tyreSizeObj.searchTerm = '';
      this.tyreSizeObj.page = 0;
      this.tyreSizeObj.list = [];
      this.getTyreSize();
    }
  }

  onTyreMakeInputChange(event: any) {
    this.tyreMakeObj.page = 0;
    this.tyreMakeObj.searchTerm = event?.term ? event.term : '';
    this.tyreMakeObj.list = [];
    this.getTyreMake();
  }

  onMakeClose() {
    if (this.tyreMakeObj.searchTerm) {
      this.tyreMakeObj.searchTerm = '';
      this.tyreMakeObj.page = 0;
      this.tyreMakeObj.list = [];
      this.getTyreMake();
    }
  }

  selectMake(value: any, index: any, isReturn: boolean) {
    let selectedTyre: any = isReturn ? this.returnStock?.controls[index] : this.replaceStock?.controls[index];
    selectedTyre?.controls['tyreModel'].setValue(null);
    this.tyreModelObj.name = '';
    this.tyreModelObj.tyreMake = value || '';
    this.tyreModelObj.page = 0;
    if (isReturn) {
      this.tyreModelReturnList[index].list = [];
      this.tyreModelReturnList[index].page = 0;
      this.tyreModelReturnList[index].search = '';
    } else {
      this.tyreModelReplaceList[index].list = [];
      this.tyreModelReplaceList[index].page = 0;
      this.tyreModelReplaceList[index].search = '';
    }
    if (value) {
      this.getTyreModel(this.tyreModelObj, index, isReturn ? 'return' : 'replace');
    }
  }

  scroll(index: number, type: 'return' | 'replace') {
    if (type === 'return') {
      let selectedTyre = this.returnStock?.controls[index] as FormGroup;
      let value = selectedTyre.controls['tyreMake'].value;
      this.tyreModelObj.tyreMake = value;
      this.tyreModelReturnList[index].page++;
      this.tyreModelObj.page = this.tyreModelReturnList[index].page;
      this.tyreModelObj.name = this.tyreModelReturnList[index].search;
    } else {
      let selectedTyre = this.replaceStock?.controls[index] as FormGroup;
      let value = selectedTyre?.controls['tyreMake'].value;
      this.tyreModelObj.tyreMake = value;
      this.tyreModelReplaceList[index].page++;
      this.tyreModelObj.page = this.tyreModelReplaceList[index].page;
      this.tyreModelObj.name = this.tyreModelReplaceList[index].search;
    }
    this.getTyreModel(this.tyreModelObj, index, type);
  }

  onTyreModelInputChange(event: any, index: number, type: 'return' | 'replace') {
    this.tyreModelObj.page = 0;
    let tyreModelSearch = event?.term ? event.term : '';
    this.tyreModelObj.name = tyreModelSearch;
    if (type === 'return') {
      this.tyreModelReturnList[index].search = tyreModelSearch;
      this.tyreModelReturnList[index].list = [];
      this.tyreModelReturnList[index].page = 0;
      let selectedTyre = this.returnStock?.controls[index] as FormGroup;
      this.tyreModelObj.tyreMake = selectedTyre.controls['tyreMake'].value;
    } else {
      this.tyreModelReplaceList[index].search = tyreModelSearch;
      this.tyreModelReplaceList[index].list = [];
      this.tyreModelReplaceList[index].page = 0;
      let selectedTyre = this.replaceStock?.controls[index] as FormGroup;
      this.tyreModelObj.tyreMake = selectedTyre?.controls['tyreMake'].value;
    }
    this.getTyreModel(this.tyreModelObj, index, type);
  }

  onReturnModelClose(index: number) {
    if (this.tyreModelReturnList[index]?.search) {
      this.tyreModelReturnList[index].search = '';
      this.tyreModelReturnList[index].list = [];
      this.tyreModelReturnList[index].page = 0;
      const make = (this.returnStock?.controls[index] as FormGroup)?.controls['tyreMake']?.value;
      if (make) {
        this.tyreModelObj.tyreMake = make;
        this.tyreModelObj.page = 0;
        this.tyreModelObj.name = '';
        this.getTyreModel(this.tyreModelObj, index, 'return');
      }
    }
  }

  onReplaceModelClose(index: number) {
    if (this.tyreModelReplaceList[index]?.search) {
      this.tyreModelReplaceList[index].search = '';
      this.tyreModelReplaceList[index].list = [];
      this.tyreModelReplaceList[index].page = 0;
      const make = (this.replaceStock?.controls[index] as FormGroup)?.controls['tyreMake']?.value;
      if (make) {
        this.tyreModelObj.tyreMake = make;
        this.tyreModelObj.page = 0;
        this.tyreModelObj.name = '';
        this.getTyreModel(this.tyreModelObj, index, 'replace');
      }
    }
  }

  initData() {
    this.tyreSizeObj.searchTerm = '';
    this.tyreSizeObj.page = 0;
    this.tyreSizeObj.list = [];
    this.tyreMakeObj.searchTerm = '';
    this.tyreMakeObj.page = 0;
    this.tyreMakeObj.list = [];
    this.tyreModelObj.name = '';
    this.getTyreSize();
    this.getTyreMake();
  }

  protected readonly faPlus = faPlus;
  protected readonly faTrash = faTrash;
}